import React, { useCallback, useMemo, useRef, useState, useEffect } from "react";

import { EditorState } from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createMentionPlugin, { defaultSuggestionsFilter } from "@draft-js-plugins/mention";
import { useSelector } from "react-redux";
import { CommentInput } from "./api";
import * as S from "./mentionStyle.js";
import { adminSelectors } from "./slice";

import "@draft-js-plugins/mention/lib/plugin.css";
import editorStyles from "./mentionStyle.css";
import userIcon from "../../../assets/images/user_icone.png";

function CommentsForm({ tripId, commentableType, handelCommentBtn, userName, scrollToTextArea }) {
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const ref = useRef();
    const currentContent = editorState.getCurrentContent().getPlainText(" ");
    const [userMention, setUserMention] = useState([]);
    const [open, setOpen] = useState(false);

    const { MentionSuggestions, plugins } = useMemo(() => {
        const mentionPlugin = createMentionPlugin({
            entityMutability: "IMMUTABLE",
            mentionPrefix: "@__",
            supportWhitespace: false,
            mentionComponent({ mention, children, className }) {
                return <span className={className}>{mention.name}</span>;
            },
        });
        // eslint-disable-next-line no-shadow
        const { MentionSuggestions } = mentionPlugin;
        // eslint-disable-next-line no-shadow
        const plugins = [mentionPlugin];
        return { plugins, MentionSuggestions };
    }, []);

    const onOpenChange = useCallback((_open) => {
        setOpen(_open);
    }, []);

    const [users, setUsers] = useState([]);
    const [suggestions, setSuggestions] = useState([]);

    let convertedAdmins = [];
    const admins = useSelector(adminSelectors());

    const initAdmins = async () => {
        if (Object.values(admins).length > 0) {
            const userAdmins = Object.values(admins).map((convertedAdmin) => ({
                name: convertedAdmin.attributes.email,
                id: convertedAdmin.id,
                link: convertedAdmin.links.self,
                avatar: userIcon,
            }));
            convertedAdmins = userAdmins;

            setUsers(userAdmins);
        }
    };

    useEffect(() => {
        // let response
        initAdmins();
        setSuggestions(convertedAdmins);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSearchChange = useCallback(
        ({ trigger, value }) => {
            setSuggestions(defaultSuggestionsFilter(value, users, trigger));
        },
        [users]
    );
    const onAddMentions = useCallback(
        (mentionSelected) => {
            const mentions = [...userMention, mentionSelected];

            setUserMention(mentions);
        },
        [userMention]
    );

    const rest = () => {
        CommentInput(currentContent, tripId, commentableType, userMention).then((res) => {
            const commentAdd = { isShow: false, itemComment: Object.values(res.entities.comments) };
            handelCommentBtn(commentAdd);
        });
    };

    return (
        <div
            className={editorStyles.editor}
            onClick={() => {
                ref.current.focus();
            }}
        >
            <div className="euiComment euiComment--hasBody sc-eJocfa kAcovy">
                <div className="euiCommentTimeline">
                    <div className="euiCommentTimeline__content">
                        <div className="euiCommentTimeline__icon--regular">
                            <img
                                src={userIcon}
                                className="euiIcon euiIcon--large"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
                <figure className="euiCommentEvent euiCommentEvent--regular">
                    <figcaption className="euiCommentEvent__header">
                        <div className="euiCommentEvent__headerData">
                            <div className="euiCommentEvent__headerUsername">{userName}</div>
                            <div className="euiCommentEvent__headerEvent">add a comment</div>
                            <div className="euiCommentEvent__headerTimestamp" />
                        </div>
                    </figcaption>
                    <div className="euiCommentEvent__body">
                        <div className="euiText euiText--small">
                            <Editor
                                editorKey="editor"
                                editorState={editorState}
                                onChange={setEditorState}
                                plugins={plugins}
                                placeholder="Type Your Comment..."
                                ref={ref}
                            />
                        </div>
                        <S.CommentSubmitButton
                            onClick={() => rest()}
                            isDisabled={
                                currentContent == null || currentContent === "" ? "isDisabled" : ""
                            }
                        >
                            Add comment
                        </S.CommentSubmitButton>
                    </div>
                </figure>
            </div>

            <MentionSuggestions
                open={open}
                onOpenChange={onOpenChange}
                suggestions={suggestions}
                onSearchChange={onSearchChange}
                onAddMention={onAddMentions}
            />
        </div>
    );
}

export default CommentsForm;
